import React, { useState } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { Button, ListItemIcon, ListItemText, MenuItem, Popover } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useAgentRefNameQuery } from '../queries/agents.queries';

function CopyReferralLinkButton() {
  const { enqueueSnackbar } = useSnackbar();
  const [menu, setMenu] = useState(null);
  const refNameQuery = useAgentRefNameQuery();
  const refName = refNameQuery.data?.data ?? '';

  const menuClick = (event) => {
    setMenu(event.currentTarget);
  };

  const menuClose = () => {
    setMenu(null);
  };
  const onCopyLinkClick = async (text: string) => {
    if (!refName) return;
    navigator.clipboard.writeText(text);
    enqueueSnackbar('Links copied to clipboard.', {
      variant: 'successToast',
      className: 'h-fit',
    });
    menuClose();
  };

  return (
    <>
      <Button
        onClick={menuClick}
        type="submit"
        className=" min-h-0 px-12 font-500 text-blue-primary p-6 min-w-0 disabled:bg-gray-400 disabled:text-opacity-60 "
      >
        <FuseSvgIcon size={18} className="mr-8">
          material-outline:content_copy
        </FuseSvgIcon>
        My Referral Links
      </Button>
      <Popover
        open={Boolean(menu)}
        anchorEl={menu}
        onClose={menuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        <MenuItem
          onClick={() => onCopyLinkClick(`https://payblox.com/cashless-atm/?agent=${refName}`)}
          className="text-blue-primary "
        >
          <ListItemIcon className="min-w-40 text-blue-primary ">
            <FuseSvgIcon size={18} className="mr-8">
              material-outline:content_copy
            </FuseSvgIcon>
          </ListItemIcon>
          <ListItemText
            primary="My Cashless ATM Solution page (1 option)"
            className="text-blue-primary "
          />
        </MenuItem>
        <MenuItem
          onClick={() => onCopyLinkClick(`https://payblox.com/agents/?agent=${refName}`)}
          className="text-blue-primary "
        >
          <ListItemIcon className="min-w-40 text-blue-primary ">
            <FuseSvgIcon size={18} className="mr-8">
              material-outline:content_copy
            </FuseSvgIcon>
          </ListItemIcon>
          <ListItemText
            primary="My Cashless ATM Solution page (2 options)"
            className="text-blue-primary "
          />
        </MenuItem>
        <MenuItem
          onClick={() =>
            onCopyLinkClick(`${window.location.origin}/agent/sign-in?token=${refName}`)
          }
          className="text-blue-primary "
        >
          <ListItemIcon className="min-w-40 text-blue-primary ">
            <FuseSvgIcon size={18} className="mr-8">
              material-outline:content_copy
            </FuseSvgIcon>
          </ListItemIcon>
          <ListItemText primary="Pre Application Link" className="text-blue-primary " />
        </MenuItem>
      </Popover>
    </>
  );
}

export default CopyReferralLinkButton;
